export default __webpack_public_path__ + "static/belknap_one-0eb94f4658a25023240752b9b841d0b3.jpeg";